import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Modal from 'srcReact/components/common2/Modal'
import Button from 'srcReact/components/common2/Button'

const DeleteWorkplacePopin = ({
  heading,
  description,
  showDeleteWorkplaceModal,
  setShowDeleteWorkplaceModal,
  handleCancelClick,
  handleClick
}) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={showDeleteWorkplaceModal} handleClose={setShowDeleteWorkplaceModal} headerCSS={styles.headerCSS}>
      <div className={styles.deleteOrganizationPopupWrapper}>
        <h5 className={styles.heading}>{heading}</h5>
        <p className={styles.description}>{description}</p>
        <div className={styles.footer}>
          <Button
            type='button'
            size='large'
            text={t('global.cancel')}
            handleClick={handleCancelClick}
            customStyle={styles.cancelButton}
          />
          <Button
            type='button'
            size='large'
            text={t('global.delete')}
            handleClick={handleClick}
            customStyle={styles.deleteButton}
          />
        </div>
      </div>
    </Modal>
  )
}

DeleteWorkplacePopin.propTypes = {
  showDeleteWorkplaceModal: PropTypes.bool,
  setShowDeleteWorkplaceModal: PropTypes.func,
  handleCancelClick: PropTypes.func,
  handleClick: PropTypes.func,
  heading: PropTypes.string,
  description: PropTypes.string
}

export default DeleteWorkplacePopin
